import { type FC } from 'react';

import { cn } from '@repo/utils/common';

import { getAssetFullPath } from '@/shared/utils/common.utils';
import type { PictureSchema } from '@/shared/validation/fetch.validation';

export type PictureProps = {
  picture: PictureSchema;
  className?: string;
  imgClassName?: string;
  alt?: string;
  style?: React.CSSProperties;
  width?: number;
  height?: number;
  sizes?: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'auto' | 'high' | 'low';
  decoding?: 'sync' | 'async';
};

export const Picture: FC<PictureProps> = ({
  picture,
  className,
  imgClassName,
  alt,
  loading,
  style,
  sizes,
  fetchPriority,
  decoding,
}) => {
  return (
    <picture className={cn('', className) || undefined}>
      {picture?.sources?.map((source) => (
        <source
          key={source?.format}
          srcSet={source?.srcSet?.map((s) => `${getAssetFullPath(s?.url)} ${s?.width}w`).join(', ')}
          type={`image/${source?.format}`}
          sizes={sizes}
        />
      ))}
      <img
        src={getAssetFullPath(picture?.default?.url)}
        alt={alt || undefined}
        className={cn('', imgClassName)}
        sizes={sizes}
        style={style}
        loading={loading}
        fetchPriority={fetchPriority}
        width={picture.default?.width || 0}
        height={picture.default?.height || 0}
        decoding={decoding}
      />
    </picture>
  );
};
